import './Safety.less';
import React from 'react';

import SafetyScoreCard from './SafetyCards/SafetyScoreCard';
import TargetScoreCard from './SafetyCards/TargetScoreCard';
import HistoryChartCard from './SafetyCards/HistoryChartCard';
import Notifications from '../../components/Notifications/Notifications';

import history from '../../history';
import { inject, observer } from 'mobx-react';
import AppLayout from '../AppLayout/AppLayout';
import PageLoadLogger from '../../utils/PageLoadLogger';

import {
  Row,
  Col,
  Button,
  AppLocaleProvider,
  Modal,
  Icon,
  ReactPlayer,
  Layout
} from 'sd-ui-components';

const { FormattedMessage } = AppLocaleProvider;
const { Footer } = Layout;
@inject('ConfigStore')
@inject('SafetyStore')
@inject('AuthStore')
@observer
class Safety extends React.Component {
  state = {
    helpVisible: false
  };

  pageLoadLogger = new PageLoadLogger('Safety');

  componentDidMount = () => {
    const isRedirect = !!JSON.parse(sessionStorage.getItem('externalRedirect'));
    if (isRedirect) {
      sessionStorage.setItem('externalRedirect', false);
      history.replace(`/safetysecure`, '_self');
    }
    this.pageLoadLogger.addRequest(this.props.SafetyStore.getSafetyScore());
    this.pageLoadLogger.capture();
  };

  componentWillUnmount() {
    this.props.SafetyStore.cancelGetSafetyScore();
  }

  onImproveMyScoreClick = () => {
    history.push(`/drivingperformance`);
  };

  toggleSafetyHelp = () => {
    this.setState({
      helpVisible: !this.state.helpVisible
    });
  };

  render() {
    const { SafetyStore, ConfigStore } = this.props;

    const helpVideoUrl = `${ConfigStore.config.staticUrl}/Videos/Driver_Help_Video.mp4`;

    return (
      <AppLayout className="safety-page-layout">
        <Row>
          <Col span={24}>
            <Notifications />
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={24}>
            <Row>
              <h1 className="driver-safety-header">
                <FormattedMessage
                  id="App.Safety.DriverSafety"
                  defaultMessage="Driver safety"
                />
                {!ConfigStore.config.betaMode && (
                  <Icon
                    icon="info-circle-o"
                    size={20}
                    className="safety-help-icon"
                    onClick={this.toggleSafetyHelp}
                  />
                )}
              </h1>
              <Modal
                title={
                  <h3>
                    <FormattedMessage
                      id="App.Safety.LearnMore"
                      defaultMessage="Learn more"
                    />
                  </h3>
                }
                visible={this.state.helpVisible}
                footer={[
                  <Button key="closeButton" onClick={this.toggleSafetyHelp}>
                    <FormattedMessage
                      id="App.Navigation.Close"
                      defaultMessage="Close"
                    />
                  </Button>
                ]}
                wrapClassName="safety-help-modal"
                closable={false}
              >
                <p>
                  <FormattedMessage
                    id="App.Safety.LearnMoreBody"
                    defaultMessage="Watch the tutorial video below on how to use the Driver website."
                  />
                </p>
                <ReactPlayer
                  url={helpVideoUrl}
                  width="100%"
                  height="100%"
                  playing={false}
                  muted={false}
                  playsinline={true}
                  controls={true}
                  config={{
                    file: {
                      attributes: {
                        controlsList: 'nodownload'
                      }
                    }
                  }}
                />
              </Modal>
            </Row>

            {!SafetyStore.loadingErrors.safetyData && (
              <div>
                <Row gutter={16}>
                  <Col
                    span={SafetyStore.targetScoreIsNull ? 24 : 12}
                    className="safety-score-column"
                  >
                    <SafetyScoreCard />
                  </Col>
                  {!SafetyStore.targetScoreIsNull && (
                    <Col span={12} className="target-score-column">
                      <TargetScoreCard />
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col span={24} className="safety-history-card-separator">
                    <HistoryChartCard />
                  </Col>
                </Row>
              </div>
            )}
          </Col>
        </Row>
        <Footer className="view-performance-footer">
          {!SafetyStore.loading.getSafetyScore && (
            <Button
              type="primary"
              size="large"
              onClick={this.onImproveMyScoreClick}
              className="button-improve-my-score"
              data-automation-id="sd-ui-driver-safety-improve-my-score-button"
              disabled={SafetyStore.driverScoreIsNull}
            >
              {SafetyStore.driverScoreIsNull && (
                <FormattedMessage
                  id="App.Safety.NoObservationsAvailable"
                  defaultMessage="No observations available"
                />
              )}

              {!SafetyStore.driverScoreIsNull && (
                <FormattedMessage
                  id="App.Safety.ViewMyPerformance"
                  defaultMessage="View my performance"
                />
              )}
            </Button>
          )}
        </Footer>
      </AppLayout>
    );
  }
}

export default Safety;



// WEBPACK FOOTER //
// ./src/containers/Safety/Safety.jsx